import { SigninAuthenticationModel } from "@factory/model/query-model-authentication";
import { CreateBirthdayRewardModel } from "@factory/model/query-model-birthday-reward";
import { UpdateBirthdayRewardModel } from "@factory/model/query-model-birthday-reward";
import { DeleteBirthdayRewardModel } from "@factory/model/query-model-birthday-reward";
import { CreateBranchModel } from "@factory/model/query-model-branch";
import { UpdateBranchModel } from "@factory/model/query-model-branch";
import { DeleteBranchModel } from "@factory/model/query-model-branch";
import {
  CreateCampaignModel,
  CreateCampaignModelExtension,
  UpdateCampaignModelExtension,
} from "@factory/model/query-model-campaign";
import { UpdateCampaignModel } from "@factory/model/query-model-campaign";
import { DeleteCampaignModel } from "@factory/model/query-model-campaign";
import { CreateCardCategoryModel } from "@factory/model/query-model-card-category";
import { UpdateCardCategoryModel } from "@factory/model/query-model-card-category";
import { DeleteCardCategoryModel } from "@factory/model/query-model-card-category";
import {
  ActivateCardSeriesModel,
  AutoAssignCardSeriesModel,
  CreateCardSeriesModel,
} from "@factory/model/query-model-card-series";
import { DeleteCardSeriesModel } from "@factory/model/query-model-card-series";
import { CreateCouponModel } from "@factory/model/query-model-coupon";
import { UpdateCouponModel } from "@factory/model/query-model-coupon";
import { DeleteCouponModel } from "@factory/model/query-model-coupon";
import {
  CreateLevelModel,
  CreateLevelModelExtension,
  UpdateLevelModelExtension,
} from "@factory/model/query-model-level";
import { UpdateLevelModel } from "@factory/model/query-model-level";
import { DeleteLevelModel } from "@factory/model/query-model-level";
import {
  CreatePersonModel,
  CreatePersonModelExtension,
  UpdatePersonModelExtension,
} from "@factory/model/query-model-person";
import { UpdatePersonModel } from "@factory/model/query-model-person";
import { DeletePersonModel } from "@factory/model/query-model-person";
import { InitializeUserLevelModel } from "@factory/model/query-model-quota-system";
import { CreateReferralModel } from "@factory/model/query-model-referral";
import { CreateReferralSettingModel } from "@factory/model/query-model-referral-setting";
import { UpdateReferralSettingModel } from "@factory/model/query-model-referral-setting";
import { DeleteReferralSettingModel } from "@factory/model/query-model-referral-setting";
import {
  CreateRegistratioModelExtension,
  CreateRegistrationModel,
} from "@factory/model/query-model-registration";
import { CreateRequestModel } from "@factory/model/query-model-request";
import { CreateRequestTypeModel } from "@factory/model/query-model-request-type";
import { UpdateRequestTypeModel } from "@factory/model/query-model-request-type";
import { DeleteRequestTypeModel } from "@factory/model/query-model-request-type";
import {
  CreateRewardModel,
  EarnRewardModel,
  RedeemRewardModel,
} from "@factory/model/query-model-reward";
import { UpdateRewardModel } from "@factory/model/query-model-reward";
import { DeleteRewardModel } from "@factory/model/query-model-reward";
import { CreateRewardEventModel } from "@factory/model/query-model-reward-event";
import { UpdateRewardEventModel } from "@factory/model/query-model-reward-event";
import { DeleteRewardEventModel } from "@factory/model/query-model-reward-event";
import { CreateRewardTypeModel } from "@factory/model/query-model-reward-type";
import { UpdateRewardTypeModel } from "@factory/model/query-model-reward-type";
import { DeleteRewardTypeModel } from "@factory/model/query-model-reward-type";
import { CreateRoleModel } from "@factory/model/query-model-role";
import { UpdateRoleModel } from "@factory/model/query-model-role";
import { DeleteRoleModel } from "@factory/model/query-model-role";
import { CreateSplashScreenExtension, CreateSplashScreenModel, UpdateSplashScreenExtension } from "@factory/model/query-model-splash-screen";
import { UpdateSplashScreenModel } from "@factory/model/query-model-splash-screen";
import { DeleteSplashScreenModel } from "@factory/model/query-model-splash-screen";
import { CreateTenantModel } from "@factory/model/query-model-tenant";
import { UpdateTenantModel } from "@factory/model/query-model-tenant";
import { DeleteTenantModel } from "@factory/model/query-model-tenant";
import { CreateTierLevelModel } from "@factory/model/query-model-tier-level";
import { UpdateTierLevelModel } from "@factory/model/query-model-tier-level";
import { DeleteTierLevelModel } from "@factory/model/query-model-tier-level";
import { CreateTransactionModel, VoidTransactionModel } from "@factory/model/query-model-transaction";
import { UpdateTransactionModel } from "@factory/model/query-model-transaction";
import { DeleteTransactionModel } from "@factory/model/query-model-transaction";
import { CreateVehicleModel, CreateVehicleModelExtension, UpdateVehicleModelExtension } from "@factory/model/query-model-vehicle";
import { UpdateVehicleModel } from "@factory/model/query-model-vehicle";
import { DeleteVehicleModel } from "@factory/model/query-model-vehicle";
import { CreateVehicleTransactionModel } from "@factory/model/query-model-vehicle-transaction";
import { UpdateVehicleTransactionModel } from "@factory/model/query-model-vehicle-transaction";
import { DeleteVehicleTransactionModel } from "@factory/model/query-model-vehicle-transaction";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

// MAPPER QUERY MODEL IMPORT
import {
BirthdayRewardFormSchema,
  BranchFormSchema,
  CampaignFormSchema,
  CardCategoryFormSchema,
  CardSeriesFormSchema,
CouponFormSchema,
  InitializeUserFormSchema,
  LevelFormSchema,
  LoginFormSchema,
  PersonFormSchema,
ReferralFormSchema,
ReferralSettingFormSchema,
  RegistrationFormSchema,
  RequestFormSchema,
  RequestTypeFormSchema,
  RewardEventFormSchema,
  RewardFormSchema,
  RewardTypeFormSchema,
  RoleFormSchema,
  SplashScreenFormSchema,
  TenantFormSchema,
  TierLevelFormSchema,
  TransactionFormSchema,
VehicleFormSchema,
VehicleTransactionFormSchema,
  VoidTransactionFormSchema,
// MAPPER IMPORT
} from "../form/form.rule";

export function useFormApiMapper() {
  const { formatDate } = useDateTimeContext();

  const mapLogin = (form: LoginFormSchema, tenant?: string) => {
    const payload = {
      username: form.username,
      password: form.password,
    } as SigninAuthenticationModel;

    if (tenant) {
      payload.slug = tenant;
    }

    return payload;
  };

  const mapCreateTenant = (form: TenantFormSchema) => {
    const payload = {
      owner: form.owner,
      slug: form.slug,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone_number: form.phoneNumber,
      website: form.website,
      membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
      post_registration_link: form.postRegistrationLink,
      post_registration_message: form.postRegistrationMessage,
      feature_quota: form.featureQuota,
      feature_splash_screen: form.featureSplashScreen,
      feature_coupon: form.featureCoupon,
      feature_referral: form.featureReferral,
      feature_birthday_email: form.featureBirthdayEmail,
      smtp_app_password: form.smtpAppPassword,
      smtp_mail_user: form.smtpMailUser,
      smtp_mail_from: form.smtpMailFrom,
      smtp_mail_content: form.smtpMailContent,
      allow_under_eighteen: form.allowUnderEighteen,
      allow_decimal_points: form.allowDecimalPoints,
      terms_and_conditions: form.termsAndConditions,
      privacy_policy: form.privacyPolicy,
    } as CreateTenantModel;

    return payload;
  };
  const mapUpdateTenant = (form: TenantFormSchema, code: string) => {
    const payload = {
      code,
      owner: form.owner,
      slug: form.slug,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone_number: form.phoneNumber,
      website: form.website,
      membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
      post_registration_link: form.postRegistrationLink,
      post_registration_message: form.postRegistrationMessage,
      feature_quota: form.featureQuota,
      feature_splash_screen: form.featureSplashScreen,
      feature_coupon: form.featureCoupon,
      feature_referral: form.featureReferral,
      feature_birthday_email: form.featureBirthdayEmail,
      smtp_app_password: form.smtpAppPassword,
      smtp_mail_user: form.smtpMailUser,
      smtp_mail_from: form.smtpMailFrom,
      smtp_mail_content: form.smtpMailContent,
      allow_under_eighteen: form.allowUnderEighteen,
      allow_decimal_points: form.allowDecimalPoints,
      terms_and_conditions: form.termsAndConditions,
      privacy_policy: form.privacyPolicy,
    } as UpdateTenantModel;

    return payload;
  };
  const mapDeleteTenant = (code: string) => {
    const payload = {
      code,
    } as DeleteTenantModel;

    return payload;
  };
  const mapCreateRole = (form: RoleFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateRoleModel;

    return payload;
  };
  const mapUpdateRole = (form: RoleFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateRoleModel;

    return payload;
  };
  const mapDeleteRole = (code: string) => {
    const payload = {
      code,
    } as DeleteRoleModel;

    return payload;
  };
  const mapCreatePerson = (form: PersonFormSchema) => {
    const payload = {
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      password: form.password,
      is_verified: form.isVerified,
      avatar: form.avatar,
      activation_code: form.activationCode,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
    } as CreatePersonModel;

    const newPayload = {
      person: payload,
      file: form.photo,
    } as CreatePersonModelExtension;

    return newPayload;
  };
  const mapUpdatePerson = (form: PersonFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      is_verified: form.isVerified,
      avatar: form.avatar,
      activation_code: form.activationCode,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
    } as UpdatePersonModel;

    if (form.password) {
      payload.password = form.password;
    }

    const newPayload = {
      person: payload,
      file: form.photo,
    } as UpdatePersonModelExtension;

    return newPayload;
  };
  const mapDeletePerson = (code: string) => {
    const payload = {
      code,
    } as DeletePersonModel;

    return payload;
  };
  const mapCreateReward = (form: RewardFormSchema) => {
    const payload = {
      tenant: form.tenant,
      is_points: form.isPoints,
      is_stamp: form.isStamp,
      denomination_points: form.denominationPoints,
      points: form.points,
      denomination_stamp: form.denominationStamp,
      stamp: form.stamp,
      is_active: form.isActive,
    } as CreateRewardModel;

    return payload;
  };
  const mapUpdateReward = (form: RewardFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      is_points: form.isPoints,
      is_stamp: form.isStamp,
      denomination_points: form.denominationPoints,
      points: form.points,
      denomination_stamp: form.denominationStamp,
      stamp: form.stamp,
      is_active: form.isActive,
    } as UpdateRewardModel;

    return payload;
  };
  const mapDeleteReward = (code: string) => {
    const payload = {
      code,
    } as DeleteRewardModel;

    return payload;
  };
  const mapEarnReward = (
    code: string,
    amount: number,
    branch: string,
    tenant: string,
    couponCode: string,
    vehicleCode: string,
    receiptNumber: string,
  ) => {
    const payload = {
      code,
      amount,
      branch,
      tenant,
      couponCode,
      vehicleCode,
      receiptNumber,
    } as EarnRewardModel;

    return payload;
  };
  const mapRedeemReward = (
    code: string,
    campaign: string,
    branch: string,
    tenant: string,
    preference: string,
    points?: number,
    stamp?: number,
  ) => {
    const payload = {
      code,
      branch,
      tenant,
      campaign,
      preference,
      points,
      stamp,
    } as RedeemRewardModel;

    return payload;
  };
  const mapCreateRewardEvent = (form: RewardEventFormSchema) => {
    const payload = {
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      is_points: form.isPoints,
      is_stamp: form.isStamp,
      is_level: form.isLevel,
      denomination_points: form.denominationPoints,
      points: form.points,
      denomination_stamp: form.denominationStamp,
      stamp: form.stamp,
      start_date: formatDate(form.startDate as Date, undefined),
      end_date: formatDate(form.endDate as Date, undefined),
      level: form.level,
    } as CreateRewardEventModel;

    return payload;
  };
  const mapUpdateRewardEvent = (form: RewardEventFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      is_points: form.isPoints,
      is_stamp: form.isStamp,
      is_level: form.isLevel,
      denomination_points: form.denominationPoints,
      points: form.points,
      denomination_stamp: form.denominationStamp,
      stamp: form.stamp,
      start_date: formatDate(form.startDate as Date, undefined),
      end_date: formatDate(form.endDate as Date, undefined),
      level: form.level,
    } as UpdateRewardEventModel;

    return payload;
  };
  const mapDeleteRewardEvent = (code: string) => {
    const payload = {
      code,
    } as DeleteRewardEventModel;

    return payload;
  };
  const mapCreateCampaign = (form: CampaignFormSchema) => {
    const campaign = {
      tenant: form.tenant,
      level: form.level,
      name: form.name,
      description: form.description,
      image: form.image,
      points: form.points,
      stamp: form.stamp,
      redeem_by_points: form.redeemByPoints,
      redeem_by_stamp: form.redeemByStamp,
      multi_redeem: form.multiRedeem,
      redeem_limit: form.redeemLimit,
      limit_per_month: form.limitPerMonth,
      start_date: formatDate(form.startDate as Date, undefined),
      end_date: formatDate(form.endDate as Date, undefined),
      for_birthday: form.forBirthday,
      birthday_window_days: form.birthdayWindowDays,
    } as CreateCampaignModel;

    const newPayload = {
      campaign,
      file: form.file,
    } as CreateCampaignModelExtension;

    return newPayload;
  };
  const mapUpdateCampaign = (form: CampaignFormSchema, code: string) => {
    const campaign = {
      code,
      tenant: form.tenant,
      level: form.level,
      name: form.name,
      description: form.description,
      image: form.image,
      points: form.points,
      stamp: form.stamp,
      redeem_by_points: form.redeemByPoints,
      redeem_by_stamp: form.redeemByStamp,
      multi_redeem: form.multiRedeem,
      redeem_limit: form.redeemLimit,
      limit_per_month: form.limitPerMonth,
      start_date: formatDate(form.startDate as Date, undefined),
      end_date: formatDate(form.endDate as Date, undefined),
      for_birthday: form.forBirthday,
      birthday_window_days: form.birthdayWindowDays,
    } as UpdateCampaignModel;

    const newPayload = {
      campaign,
      file: form.file,
    } as UpdateCampaignModelExtension;

    return newPayload;
  };
  const mapDeleteCampaign = (code: string) => {
    const payload = {
      code,
    } as DeleteCampaignModel;

    return payload;
  };
  const mapCreateRewardType = (form: RewardTypeFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
      tenant: form.tenant,
    } as CreateRewardTypeModel;

    return payload;
  };
  const mapUpdateRewardType = (form: RewardTypeFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
      tenant: form.tenant,
    } as UpdateRewardTypeModel;

    return payload;
  };
  const mapDeleteRewardType = (code: string) => {
    const payload = {
      code,
    } as DeleteRewardTypeModel;

    return payload;
  };
  const mapCreateRequestType = (form: RequestTypeFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateRequestTypeModel;

    return payload;
  };
  const mapUpdateRequestType = (form: RequestTypeFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateRequestTypeModel;

    return payload;
  };
  const mapDeleteRequestType = (code: string) => {
    const payload = {
      code,
    } as DeleteRequestTypeModel;

    return payload;
  };
  const mapCreateTransaction = (form: TransactionFormSchema) => {
    const payload = {
      tenant: form.tenant,
      branch: form.branch,
      user_code: form.userCode,
      card_series: form.cardSeries,
      reward: form.reward,
      campaign: form.campaign,
      action: form.action,
      amount: form.amount,
      points: form.points,
      stamp: form.stamp,
      remarks: form.remarks,
    } as CreateTransactionModel;

    return payload;
  };
  const mapUpdateTransaction = (form: TransactionFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      branch: form.branch,
      user_code: form.userCode,
      card_series: form.cardSeries,
      reward: form.reward,
      campaign: form.campaign,
      action: form.action,
      amount: form.amount,
      points: form.points,
      stamp: form.stamp,
      remarks: form.remarks,
    } as UpdateTransactionModel;

    return payload;
  };
  const mapDeleteTransaction = (code: string) => {
    const payload = {
      code,
    } as DeleteTransactionModel;

    return payload;
  };
  const mapVoidTransaction = (
    form: VoidTransactionFormSchema,
    code: string,
  ) => {
    const payload = {
      code,
      voided_by: form.voidedBy,
      authentication: form.authentication,
    } as VoidTransactionModel;

    return payload;
  };
  const mapCreateBranch = (form: BranchFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
      head: form.head,
      tenant: form.tenant,
    } as CreateBranchModel;

    return payload;
  };
  const mapUpdateBranch = (form: BranchFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
      head: form.head,
      tenant: form.tenant,
    } as UpdateBranchModel;

    return payload;
  };
  const mapDeleteBranch = (code: string) => {
    const payload = {
      code,
    } as DeleteBranchModel;

    return payload;
  };
  const mapCreateCardSeries = (form: CardSeriesFormSchema) => {
    const payload = {
      tenant: form.tenant,
      card_category: form.cardCategory,
      quantity: form.quantity,
    } as CreateCardSeriesModel;

    return payload;
  };
  const mapUpdateCardSeries = (form: CardSeriesFormSchema, code: string) => {
    const payload = {
      code,
      user_code: form.cardOwner,
    } as ActivateCardSeriesModel;

    if (form.pin) {
      payload.pin = form.pin;
    }

    return payload;
  };
  const mapAutoAssignCardSeries = (
    cardOwner: string,
    cardCategory: string,
    tenant: string,
  ) => {
    const payload = {
      user_code: cardOwner,
      // card_category: cardCategory,
      tenant: tenant,
    } as AutoAssignCardSeriesModel;

    return payload;
  };
  const mapActivateCardSeries = (form: CardSeriesFormSchema) => {
    const payload = {
      code: form.cardCode,
      user_code: form.cardOwner,
    } as ActivateCardSeriesModel;

    return payload;
  };
  const mapDeleteCardSeries = (code: string) => {
    const payload = {
      code,
    } as DeleteCardSeriesModel;

    return payload;
  };
  const mapCreateLevel = (form: LevelFormSchema) => {
    const payload = {
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      avatar: form.avatar,
      points: form.points,
      stamp: form.stamp,
      constraint: form.constraint,
      max_points: form.maxPoints,
      max_stamp: form.maxStamp,
      max_points_per_day: form.maxPointsPerDay,
      max_stamp_per_day: form.maxStampPerDay,
    } as CreateLevelModel;

    const newPayload = {
      level: payload,
      file: form.file,
    } as CreateLevelModelExtension;

    return newPayload;
  };
  const mapUpdateLevel = (form: LevelFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      avatar: form.avatar,
      points: form.points,
      stamp: form.stamp,
      constraint: form.constraint,
      max_points: form.maxPoints,
      max_stamp: form.maxStamp,
      max_points_per_day: form.maxPointsPerDay,
      max_stamp_per_day: form.maxStampPerDay,
    } as UpdateLevelModel;

    const newPayload = {
      level: payload,
      file: form.file,
    } as UpdateLevelModelExtension;

    return newPayload;
  };
  const mapDeleteLevel = (code: string) => {
    const payload = {
      code,
    } as DeleteLevelModel;

    return payload;
  };
  const mapCreateCardCategory = (form: CardCategoryFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
      tenant: form.tenant,
      expiration_years: form.expirationYears,
    } as CreateCardCategoryModel;

    return payload;
  };
  const mapUpdateCardCategory = (
    form: CardCategoryFormSchema,
    code: string,
  ) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
      tenant: form.tenant,
      expiration_years: form.expirationYears,
    } as UpdateCardCategoryModel;

    return payload;
  };
  const mapDeleteCardCategory = (code: string) => {
    const payload = {
      code,
    } as DeleteCardCategoryModel;

    return payload;
  };
  const mapCreateRequest = (form: RequestFormSchema) => {
    const payload = {
      tenant: form.tenant,
      user_code: form.userCode,
      card_series: form.cardSeries,
      campaign: form.campaign,
      expiration: form.expiration,
      coupon: form.coupon,
    } as CreateRequestModel;

    return payload;
  };
  const mapCreateRegistration = (form: RegistrationFormSchema) => {
    const payload = {
      tenant: form.tenant,
      branch: form.branch,
      card_category: form.cardCategory,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      gender: form.gender,
      birthday: form.birthday,
      username: form.username,
      password: form.password,
      email: form.email,
      mobile_number: form.mobileNumber,
      avatar: form.avatar,
      expiration: form.expiration,
      status: form.status,
      remarks: form.remarks,
      referral_code: form.referralCode,
    } as CreateRegistrationModel;

    const newPayload = {
      registration: payload,
      file: form.photo,
    } as CreateRegistratioModelExtension;

    return newPayload;
  };
  const mapInitializeUser = (form: InitializeUserFormSchema) => {
    const payload = {
      user_code: form.userCode,
      registration_date: form.registrationDate,
    } as InitializeUserLevelModel;

    return payload;
  };
  const mapCreateTierLevel = (form: TierLevelFormSchema) => {
		const payload = {
		tenant: form.tenant,
		name: form.name,
		level: form.level,
		min_amount: form.minAmount,
		max_amount: form.maxAmount,
		description: form.description,
		} as CreateTierLevelModel;

		return payload;
	};
	const mapUpdateTierLevel = (form: TierLevelFormSchema, code: string) => {
		const payload = {
			code,
		tenant: form.tenant,
		name: form.name,
		level: form.level,
		min_amount: form.minAmount,
		max_amount: form.maxAmount,
		description: form.description,
		} as UpdateTierLevelModel;

		return payload;
	};
	const mapDeleteTierLevel = (code: string) => {
		const payload = {
			code
		} as DeleteTierLevelModel;

		return payload;
	};
	const mapCreateSplashScreen = (form: SplashScreenFormSchema) => {
		const payload = {
		name: form.name,
		tenant: form.tenant,
		image: form.image,
		description: form.description,
		link: form.link,
		} as CreateSplashScreenModel;

    const newPayload = {
      splashScreen: payload,
      file: form.file,
    } as CreateSplashScreenExtension;

		return newPayload;
	};
	const mapUpdateSplashScreen = (form: SplashScreenFormSchema, code: string) => {
		const payload = {
			code,
		name: form.name,
		tenant: form.tenant,
		image: form.image,
		description: form.description,
		link: form.link,
		} as UpdateSplashScreenModel;

    const newPayload = {
      splashScreen: payload,
      file: form.file,
    } as UpdateSplashScreenExtension;

		return newPayload;
	};
	const mapDeleteSplashScreen = (code: string) => {
		const payload = {
			code
		} as DeleteSplashScreenModel;

		return payload;
	};
	const mapCreateCoupon = (form: CouponFormSchema) => {
		const payload = {
		tenant: form.tenant,
		name: form.name,
		description: form.description,
		coupon_code: form.couponCode,
		valid_until: form.validUntil,
		level: form.level,
		purpose: form.purpose,
		value_type: form.valueType,
		points: form.points,
		stamps: form.stamps,
		redeem_limit: form.redeemLimit,
		is_user_redeemable: form.isUserRedeemable,
		} as CreateCouponModel;

		return payload;
	};
	const mapUpdateCoupon = (form: CouponFormSchema, code: string) => {
		const payload = {
			code,
		tenant: form.tenant,
		name: form.name,
		description: form.description,
		coupon_code: form.couponCode,
		valid_until: form.validUntil,
		level: form.level,
		purpose: form.purpose,
		value_type: form.valueType,
		points: form.points,
		stamps: form.stamps,
		redeem_limit: form.redeemLimit,
		is_user_redeemable: form.isUserRedeemable,
		} as UpdateCouponModel;

		return payload;
	};
	const mapDeleteCoupon = (code: string) => {
		const payload = {
			code
		} as DeleteCouponModel;

		return payload;
	};
	const mapCreateReferralSetting = (form: ReferralSettingFormSchema) => {
		const payload = {
		tenant: form.tenant,
		points: form.points,
		stamp: form.stamp,
		referral_type: form.referralType,
		} as CreateReferralSettingModel;

		return payload;
	};
	const mapUpdateReferralSetting = (form: ReferralSettingFormSchema, code: string) => {
		const payload = {
			code,
		tenant: form.tenant,
		points: form.points,
		stamp: form.stamp,
		referral_type: form.referralType,
		} as UpdateReferralSettingModel;

		return payload;
	};
	const mapDeleteReferralSetting = (code: string) => {
		const payload = {
			code
		} as DeleteReferralSettingModel;

		return payload;
	};
	const mapCreateReferral = (form: ReferralFormSchema) => {
		const payload = {
		tenant: form.tenant,
		referrer: form.referrer,
		referee: form.referee,
		status: form.status,
		} as CreateReferralModel;

		return payload;
	};
	const mapCreateBirthdayReward = (form: BirthdayRewardFormSchema) => {
		const payload = {
		tenant: form.tenant,
		points: form.points,
		stamp: form.stamp,
		expiry_days: form.expiryDays,
		} as CreateBirthdayRewardModel;

		return payload;
	};
	const mapUpdateBirthdayReward = (form: BirthdayRewardFormSchema, code: string) => {
		const payload = {
			code,
		tenant: form.tenant,
		points: form.points,
		stamp: form.stamp,
		expiry_days: form.expiryDays,
		} as UpdateBirthdayRewardModel;

		return payload;
	};
	const mapDeleteBirthdayReward = (code: string) => {
		const payload = {
			code
		} as DeleteBirthdayRewardModel;

		return payload;
	};
	const mapCreateVehicle = (form: VehicleFormSchema) => {
		const payload = {
		tenant: form.tenant,
		user_code: form.userCode,
		plate_number: form.plateNumber,
		make: form.make,
		model: form.model,
		year: form.year,
		color: form.color,
		nickname: form.nickname,
		remarks: form.remarks,
		avatar: form.avatar,
		is_blocked: form.isBlocked,
		} as CreateVehicleModel;

    const newPayload = {
      vehicle: payload,
      file: form.file,
    } as CreateVehicleModelExtension;

    return newPayload;
	};
	const mapUpdateVehicle = (form: VehicleFormSchema, code: string) => {
		const payload = {
			code,
		tenant: form.tenant,
		user_code: form.userCode,
		plate_number: form.plateNumber,
		make: form.make,
		model: form.model,
		year: form.year,
		color: form.color,
		nickname: form.nickname,
		remarks: form.remarks,
		avatar: form.avatar,
		is_blocked: form.isBlocked,
		} as UpdateVehicleModel;

    const newPayload = {
      vehicle: payload,
      file: form.file,
    } as UpdateVehicleModelExtension;

    return newPayload;
	};
	const mapDeleteVehicle = (code: string) => {
		const payload = {
			code
		} as DeleteVehicleModel;

		return payload;
	};
	const mapCreateVehicleTransaction = (form: VehicleTransactionFormSchema) => {
		const payload = {
		tenant: form.tenant,
		vehicle: form.vehicle,
		transaction: form.transaction,
		user_code: form.userCode,
		} as CreateVehicleTransactionModel;

		return payload;
	};
	const mapUpdateVehicleTransaction = (form: VehicleTransactionFormSchema, code: string) => {
		const payload = {
			code,
		tenant: form.tenant,
		vehicle: form.vehicle,
		transaction: form.transaction,
		user_code: form.userCode,
		} as UpdateVehicleTransactionModel;

		return payload;
	};
	const mapDeleteVehicleTransaction = (code: string) => {
		const payload = {
			code
		} as DeleteVehicleTransactionModel;

		return payload;
	};
	// MAPPER FUNCTION

  return {
    mapLogin,
    mapCreateTenant,
    mapUpdateTenant,
    mapDeleteTenant,
    mapCreateRole,
    mapUpdateRole,
    mapDeleteRole,
    mapCreatePerson,
    mapUpdatePerson,
    mapDeletePerson,
    mapCreateReward,
    mapUpdateReward,
    mapDeleteReward,
    mapEarnReward,
    mapRedeemReward,
    mapCreateRewardEvent,
    mapUpdateRewardEvent,
    mapDeleteRewardEvent,
    mapCreateCampaign,
    mapUpdateCampaign,
    mapDeleteCampaign,
    mapCreateRewardType,
    mapUpdateRewardType,
    mapDeleteRewardType,
    mapCreateRequestType,
    mapUpdateRequestType,
    mapDeleteRequestType,
    mapCreateTransaction,
    mapUpdateTransaction,
    mapDeleteTransaction,
    mapVoidTransaction,
    mapCreateBranch,
    mapUpdateBranch,
    mapDeleteBranch,
    mapCreateCardSeries,
    mapUpdateCardSeries,
    mapAutoAssignCardSeries,
    mapActivateCardSeries,
    mapDeleteCardSeries,
    mapCreateLevel,
    mapUpdateLevel,
    mapDeleteLevel,
    mapCreateCardCategory,
    mapUpdateCardCategory,
    mapDeleteCardCategory,
    mapCreateRequest,
    mapCreateRegistration,
    mapInitializeUser,
    mapCreateTierLevel,
mapUpdateTierLevel,
mapDeleteTierLevel,
mapCreateSplashScreen,
mapUpdateSplashScreen,
mapDeleteSplashScreen,
mapCreateCoupon,
mapUpdateCoupon,
mapDeleteCoupon,
mapCreateReferralSetting,
mapUpdateReferralSetting,
mapDeleteReferralSetting,
mapCreateReferral,
mapCreateBirthdayReward,
mapUpdateBirthdayReward,
mapDeleteBirthdayReward,
mapCreateVehicle,
mapUpdateVehicle,
mapDeleteVehicle,
mapCreateVehicleTransaction,
mapUpdateVehicleTransaction,
mapDeleteVehicleTransaction,
// MAPPER RETURN
  };
}
